import React from 'react'

import { Pressable, Stack, XStack } from '@zet/design-system'
import { M14, M8 } from '@zet/integration-flow/components/typography'

interface FilterTab {
  key: string
  displayText: string
}

interface FilterTabsProps {
  tabs: FilterTab[]
  selectedTab: string
  onTabSelect: (tabKey: string) => void
  filterCounts?: Record<string, number>
}

export const FilterTabs: React.FC<FilterTabsProps> = ({
  tabs,
  selectedTab,
  onTabSelect,
  filterCounts = {},
}) => {
  return (
    <XStack className="mb-2">
      {tabs?.map((tab, index) => {
        const isSelected = selectedTab === tab.key
        const isFirst = index === 0
        const count = filterCounts[tab.key] || 0

        return (
          <Pressable key={tab.key} onPress={() => onTabSelect(tab.key)}>
            <XStack className="items-center">
              <M14
                className={`my-2 px-[5px] ${isFirst ? 'mr-2' : 'mx-2'} ${isSelected ? 'text-black' : 'text-[#24262B]'}`}
              >
                {tab.displayText}
              </M14>
              {tab.key !== 'sort' && count > 0 && (
                <M8 className="text-[#13002D] bg-primary-10 px-[5px] py-0.5 rounded-full">
                  {count}
                </M8>
              )}
            </XStack>
            {isSelected && (
              <Stack
                className={`h-[2px] w-full bg-[#CEA15A] px-2 overflow-hidden ${
                  isFirst ? 'ml-[-4px]' : ''
                }`}
              />
            )}
          </Pressable>
        )
      })}
    </XStack>
  )
}
